export default __webpack_public_path__ + "static/media/partner-light-1.f18edcf9.png";